import {prepareDeleteDialog} from './dialog_helper.js';

$(document).ready(() => $('.soft-delete-Device').click(function(e) {
    e.preventDefault();
    const url = $(this).data('data-source');
    const hardDelete = $(this).data('hard-delete');
    const title = $(this).data('title');
    const inactive = $(this).data('inactive');
    return $.ajax({
        url,
        type: 'GET',
        dataType: 'json',
        success(returnedData) { 
            return prepareDeleteDialog('device', url, returnedData, hardDelete, title, inactive);
        }
    });
}));       
